import { render, staticRenderFns } from "./TagsDropdown.vue?vue&type=template&id=328487e6"
import script from "./TagsDropdown.vue?vue&type=script&lang=js"
export * from "./TagsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports